import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "name", "id", "disabled", "aria-describedby"]

import { useInputModel } from '@src/components/shared/form_elements/useInputModel';

interface Props {
	modelValue: Array<string | number>;
	nativeValue: string | number | boolean;
	name: string;
	inputId: string;
	disabled?: boolean;
	ariaDescribedby?: string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxMultipleFormInput',
  props: {
    modelValue: {},
    nativeValue: { type: [String, Number, Boolean] },
    name: {},
    inputId: {},
    disabled: { type: Boolean, default: false },
    ariaDescribedby: {}
  },
  emits: [ 'update:modelValue' ],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const inputModel = useInputModel<Array<string | number>>( () => props.modelValue, props.modelValue, emit );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", null, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null)),
      value: __props.nativeValue,
      type: "checkbox",
      name: __props.name,
      id: __props.inputId,
      disabled: __props.disabled ? true : null,
      "aria-describedby": __props.ariaDescribedby
    }, null, 8, _hoisted_1), [
      [_vModelCheckbox, _unref(inputModel)]
    ]),
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})